import {connect} from 'react-redux';
import ValidateNIPBureauView from '../../../components/views/mx/farrera/ValidateNIPBureauView';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ModalActions from '../../../actions/ModalActions';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapStateToProps = (state) => {
    const personal = state.farrera.loanApplication.applicantPersonal;
    const nip = state.farrera.loanApplication.nip;
    return {
        name: `${personal.firstName} ${personal.lastName}`,
        email: personal.email,
        phone: personal.cellPhone,
        nip: nip.identityBureau,
        counter: state.globalValidations.smsTimerResend,
        hasNipValidationError: state.farrera.ui.bureauValidateNipView.hasNipValidationError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeNIP: nip => dispatch(WizardMXActions.CHANGE_BUREAU_NIP_ACTION.action(nip)),
        onPressResendNIP: () => dispatch(WizardMXActions.RESEND_NIP_MX_ACTION.action()),
        onPressEditApplicantDataForNIP: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
            dispatch(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action());
        },
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.NIP_BUREAU);
            dispatch(WizardMXActions.VALIDATE_NIP_MX_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const ValidateNIPBureauContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ValidateNIPBureauView);

export default ValidateNIPBureauContainer;
